// React
import {
	useEffect,
	useState,
} from 'react';

import { useSelector } from 'react-redux';
import {
	useNavigate,
	useParams,
} from 'react-router-dom';

import { Credits } from '../credits/Credits';
import { LandingPage } from '../landingPage/LandingPage';
import { Language } from '../language/Language';
import { Sphere360 } from '../sphere360/Sphere360';
import { Loader } from './Loader';
// Components
import { Menu } from './Menu';

export const Home = (props: any) => {
	const language: string = useSelector((state: any) => state.user.language);
	const navigate = useNavigate();
	const { place } = useParams();

	const [videoName, setVideoName] = useState('OSTENDE_CORDIER_NL_3K');
	const [audioName, setAudioName] = useState('AUDIODESC_TOUWSLAGER_NLBE');
	const [maxSize, setMaxSize] = useState(8192);
	const [isLangSet, setIsLangSet] = useState(false);
	const [landingPage, setLandingPage] = useState(false);
	const [buffered, setBuffered] = useState(0);

	const [pausedSince, setPausedSince] = useState(50);
	const [loader, setLoader] = useState(false);

	const [credits, displayCredits] = useState(false);

	useEffect(() => { }, [buffered]);

	useEffect(() => {
		let inter = setInterval(() => {
			if (pausedSince > 0) {
				if (Date.now() - pausedSince > 1000) {
					setLoader(true);
					return;
				}
			}
			setLoader(false);
		}, 1000);

		return () => clearInterval(inter);
	});

	useEffect(() => { }, [pausedSince]);

	useEffect(() => {
		if (landingPage) {
			setTimeout(() => {
				setIsLangSet(true);
			}, 500);
		}

		if (isLangSet && !landingPage) {
			let videoElement = document.getElementById('video');

			let viewport = document.getElementById('viewport');

			if (viewport) {
				viewport.style.opacity = '1';
				viewport.style.width = '100%';
				viewport.style.height = '100%';
			}

			if (videoElement) {
				videoElement.oncanplaythrough = function () {
					if (isLangSet) {
						(videoElement as HTMLVideoElement).play();
					}
				};
			}
		}
	}, [landingPage]);

	const newName = (lang: string) => {
		let videoBase = '';
		let audioBase = '';

		if (place && place !== '') {
			switch (place) {
				case 'touwslagerij':
					videoBase = 'OSTENDE_CORDIER';
					audioBase = 'AUDIODESC_TOUWSLAGER';
					break;
				case 'kaatsbaan':
					videoBase = 'OSTENDE_KAATSBAAN';
					audioBase = 'AUDIODESC_KAATSBAAN';
					break;
				case 'kapel':
					videoBase = 'OSTENDE_KAPEL';
					audioBase = 'AUDIODESC_KAPEL';
					break;
				case 'molen':
					videoBase = 'OSTENDE_MOULIN';
					audioBase = 'AUDIODESC_MOLEN';
					break;
				case 'vissers':
					videoBase = 'OSTENDE_VISSERS';
					audioBase = 'AUDIODESC_VISSERS';
					break;
				default:
					navigate('/touwslagerij');
			}

			let videoLang = '';
			let audioLang = '';
			switch (lang) {
				case 'de':
					videoLang = '_DE';
					audioLang = '_DE';
					break;
				case 'en':
					videoLang = '_EN';
					audioLang = '_EN';
					break;
				case 'nl':
					videoLang = '_NL';
					audioLang = '_NLBE';
					break;
				case 'fr':
					videoLang = '_FR';
					audioLang = '_FR';
					break;
				default:
					videoLang = '_NL';
					audioLang = '_NLBE';
			}

			const name = videoBase + videoLang + '_3K';
			console.log('VideoName =', name);
			setVideoName(name);
			setAudioName(audioBase + audioLang);
		} else {
			navigate('/touwslagerij');
		}
	};

	useEffect(() => {
		let videoElem = document.getElementById('video')
		//let elem = document.getElementById('srcvideo');

		if (videoElem/* && elem*/) {
			//(elem as HTMLSourceElement).src = 'assets/videos/' + videoName + '.mp4';
			(videoElem as HTMLVideoElement).src = '/assets/videos/' + videoName + '.mp4';
			(videoElem as HTMLVideoElement).load();
		}

	}, [videoName])

	useEffect(() => {
		let audioElem = document.getElementById('audio');
		if (audioElem) {
			(audioElem as HTMLAudioElement).src = '/assets/audios/' + audioName + '.mp3';
			(audioElem as HTMLAudioElement).load();
		}
	}, [audioName])

	useEffect(() => {
		console.log('↳ Place: ', place);

		newName(language);
	}, [language]);

	return (
		<div style={{ width: '100%', height: '100%' }}>
			{/* THREE Instance */}
			{isLangSet && <Menu landingPage={landingPage} setLandingPage={setLandingPage} displayCredits={displayCredits} />}
			{isLangSet && <Sphere360 setMaxSize={setMaxSize} />}
			<div className='home'>
				{/* Video hide in background */}
				<video
					id='video'
					loop
					playsInline
					preload='metadata'
					width='0'
					height='0'
					src={'/assets/videos/' + videoName + '.mp4'}
					style={{
						position: 'absolute',
						opacity: 0,
						margin: 0,
						padding: 0,
					}}
					crossOrigin='anonymous'
					onCanPlay={(e) => {
						if (isLangSet) {
							e.currentTarget.play();
						}
					}}
					onWaiting={(e) => {
						setPausedSince(Date.now());
					}}
					onPlaying={(e) => {
						setPausedSince(-1);
					}}
					onProgress={(e) => {
						let video = e.currentTarget;

						if (video) {
							if (video.buffered.length > 0) {
								var bufferedEnd = video.buffered.end(video.buffered.length - 1);
								var duration = video.duration;
								if (duration > 0) {
									let bufferedAmount = document.getElementById('buffered-amount');
									if (bufferedAmount) {
										bufferedAmount.style.width = (bufferedEnd / duration) * 100 + '%';
										setBuffered(Math.trunc((bufferedEnd / duration) * 100));
									}
								}
							}
						}
					}}
					onTimeUpdate={(e) => {
						let video = e.currentTarget;

						if (video) {
							var duration = video.duration;
							if (duration > 0) {
								let progressAmount = document.getElementById('progress-amount');
								if (progressAmount) {
									progressAmount.style.width = (video.currentTime / duration) * 100 + '%';
								}
							}
						}
					}}
				>
					{/* <source id="srcvideo" src={'assets/videos/' + videoName + '.mp4'} type='video/mp4'></source> */}
					{/* <source src={'./assets/videos/' + videoName + '.webm'} type='video/webm'></source> */}
				</video>
				<audio
					id='audio'
					playsInline
					preload='metadata'
					src={'/assets/audios/' + audioName + '.mp3'}
					style={{
						position: 'absolute',
						opacity: 0,
						margin: 0,
						padding: 0,
					}}
					crossOrigin='anonymous'
					onCanPlay={(e) => {
						// if (isLangSet) {
						// 	e.currentTarget.play();
						// }
					}}
					onWaiting={(e) => {
						// setPausedSince(Date.now());
					}}
					onPlaying={(e) => {
						// setPausedSince(-1);
					}}
					onProgress={(e) => {
						// let video = e.currentTarget;

						// if (video) {
						// 	if (video.buffered.length > 0) {
						// 		var bufferedEnd = video.buffered.end(video.buffered.length - 1);
						// 		var duration = video.duration;
						// 		if (duration > 0) {
						// 			let bufferedAmount = document.getElementById('buffered-amount');
						// 			if (bufferedAmount) {
						// 				bufferedAmount.style.width = (bufferedEnd / duration) * 100 + '%';
						// 				setBuffered(Math.trunc((bufferedEnd / duration) * 100));
						// 			}
						// 		}
						// 	}
						// }
					}}
					onTimeUpdate={(e) => {
						// let video = e.currentTarget;

						// if (video) {
						// 	var duration = video.duration;
						// 	if (duration > 0) {
						// 		let progressAmount = document.getElementById('progress-amount');
						// 		if (progressAmount) {
						// 			progressAmount.style.width = (video.currentTime / duration) * 100 + '%';
						// 		}
						// 	}
						// }
					}}
				>
					{/* <source id="srcaudio" src={'assets/audios/' + videoName + '.mp3'} type='video/mp4'></source> */}
					{/* <source src={'./assets/videos/' + videoName + '.webm'} type='video/webm'></source> */}
				</audio>
				<div
					className='buffered'
					style={{
						height: '8px',
						position: 'absolute',
						background: '#555',
						width: 'calc(100% - 20px)',
						left: '10px',
						bottom: '10px',
						opacity: '0.4',
					}}
				>
					<span
						id='buffered-amount'
						style={{
							display: 'block',
							height: '100%',
							backgroundColor: '#888',
							width: '0',
						}}
					></span>
				</div>
				<div
					className='progress'
					style={{
						height: '8px',
						position: 'absolute',
						width: 'calc(100% - 20px)',
						left: '10px',
						bottom: '10px',
						opacity: '0.3',
					}}
				>
					<span
						id='progress-amount'
						style={{
							display: 'block',
							height: '100%',
							backgroundColor: '#595',
							width: '0',
						}}
					></span>
				</div>

				{/* Choose Language */}
				{!isLangSet && (
					<Language
						place={place}
						next={() => {
							setLandingPage(true);
						}}
					/>
				)}

				{/* Landing Page */}
				{landingPage && (
					<LandingPage
						place={place}
						next={() => {
							setPausedSince(Date.now());

							let videoElement = document.getElementById('video');
							if (videoElement) {
								(videoElement as HTMLVideoElement).play();
							} else {
								alert('video not ok');
							}

							setTimeout(() => {
								setIsLangSet(true);
								setLandingPage(false);
							}, 500);
						}}
					/>
				)}
			</div>
			{loader && isLangSet && !landingPage && <Loader buffered={buffered} />}
			{/* <div
				id='debug'
				style={{
					display: 'none',
					position: 'absolute',
					width: '300px',
					height: '150px',
					backgroundColor: 'red',
					top: '70px',
					left: '10px',
					color: 'black',
				}}
			></div> */}

			{credits && <Credits displayCredits={displayCredits} />}
		</div>
	);
};
